import React from 'react'
import { LaTercera } from '@labcon/copesa-logos'
import Button from '@/components/Button'
import styled from 'styled-components'

const StyledHeader = styled.header`
  backdrop-filter: saturate(180%) blur(5px);
  background-color: rgba(255, 255, 255, 0.8);
`

const Header = () => (
  <StyledHeader className="fixed top-0 left-0 right-0 border-solid border-gray-300 z-20 shadow-md">
    <div className="flex items-center justify-center h-16 mx-auto container sm:px-4 px-2 lg:px-20">
      <a
        target="_blank"
        className="block"
        href="https://www.latercera.com/?utm_source=landingbienvenida&utm_medium=web&utm_campaign=logo-latercera&utm_content=logo-latercera-header">
        <LaTercera width="200" height="20" />
      </a>
    </div>
  </StyledHeader>
)

export default Header
